import {Component, OnInit} from '@angular/core';
import {ContractsDataService} from '../_services/contracts-data.service';
import {ContractModel} from '../_models/contract.model';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'app-list-contracts',
    templateUrl: './list-contracts.component.html',
    styleUrls: ['./list-contracts.component.scss']
})

export class ListContractsComponent implements OnInit {

    constructor(private contractsData: ContractsDataService) {
    }

    filterObjectData: object;
    contractList: Array<ContractModel>;

    // Pagination
    page = 1; // Page selected at start
    pageSize = 8; // How many post per page

    // Sorting
    sortName = 'contractDate'; // Sorting Name Input
    sortDirOrder = 'desc'; // Sorting Order
    totalElements: number; // Total Elements you get from the request

    // Filtering
    nameFilter: string;
    docNumberFilter: string;
    clientNameFilter: string;
    statusFilter: any = '';

    ngOnInit() {
        this.listContractFilter();
    }

    listContractFilter() {

        this.filterObjectData = {
            name: this.nameFilter != "" ? this.nameFilter : undefined,
            docNumber: this.docNumberFilter != "" ? this.docNumberFilter : undefined,
            clientName: this.clientNameFilter != "" ? this.clientNameFilter : undefined,
            status: this.statusFilter !== '' ? this.statusFilter : undefined
        }

        this.contractsData.listContractFilter(this.pageSize, this.page, this.sortName, this.sortDirOrder, this.filterObjectData).subscribe((resp: any) => {
            this.contractList = resp.content;
            this.totalElements = resp.totalElements;
        })
    }

    resetForm(searchForm: NgForm){
        searchForm.resetForm()
        this.filterObjectData = {}
        this.contractsData.listContractFilter(this.pageSize, this.page, this.sortName, this.sortDirOrder, this.filterObjectData).subscribe((resp: any) => {
            this.contractList = resp.content;
            this.totalElements = resp.totalElements;
        })
    }

    onPageChange(page: number) {
        this.page = page;
        this.listContractFilter();
    }

    selectPageElements(event: any) {
        this.pageSize = event.target.value;
        this.page = 1;
        this.listContractFilter();
    }

    selectSortValue(event: any) {
        this.sortName = event.target.value;
        this.page = 1;
        this.listContractFilter();
    }

    changeOrderDirection(event: any) {
        this.sortDirOrder = event.target.value;
        this.page = 1;
        this.listContractFilter();
    }

}
